import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datalabs',
  standalone: true,
  imports:[],
  templateUrl: './page-datalabs.component.html',
  styleUrls: ['./page-datalabs.component.scss']
})
export class PageDatalabsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
